export default __webpack_public_path__ + "static/0197-7586ec055c2b1a7e9493f04bf0a2bdb8.png";